import { render, staticRenderFns } from "./ModalBundlePayments.vue?vue&type=template&id=e523e890&scoped=true&"
import script from "./ModalBundlePayments.vue?vue&type=script&lang=ts&"
export * from "./ModalBundlePayments.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBundlePayments.vue?vue&type=style&index=0&id=e523e890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e523e890",
  null
  
)

export default component.exports